import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import { ListItem, ListItemText, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AppsIcon from "@mui/icons-material/Apps";
import DevicesOtherIcon from "@mui/icons-material/DevicesOther";
import HardwareIcon from "@mui/icons-material/Hardware";
import PersonIcon from "@mui/icons-material/Person";
import TerminalIcon from "@mui/icons-material/Terminal";
import WebhookIcon from "@mui/icons-material/Webhook";
import { useIsAfterSalesAdmin, useIsFactoryAdmin } from "../../main/auth";
import { MqttStatusIcon } from "../../main/devices";
import NavItem from "./nav-item";
import SyncDatabasesButton from "./sync-databases-button";
import ResetDatabasesButton from "./reset-databases-button";
import { Storefront, Science as ScienceIcon, Assessment as AssessmentIcon, TrendingUp as TrendingUpIcon, Speed as SpeedIcon } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const drawerWidth = 240;

export default function Sidebar() {
  const isFactoryAdmin = useIsFactoryAdmin();
  const isAfterSalesAdmin = useIsAfterSalesAdmin();
  const { t } = useTranslation();

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: "border-box" },
      }}
    >
      <Toolbar />
      <Box sx={{ overflow: "auto" }}>
        {(isFactoryAdmin || isAfterSalesAdmin) && (
        <List>
          <ListItem>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              flexGrow={1}
              spacing={2}
            >
              {t("SIDEBAR.SYNCHRONIZE")}
              <Stack direction="row" alignItems="center" spacing={1}>
                <SyncDatabasesButton />
                <ResetDatabasesButton />
              </Stack>
            </Stack>
          </ListItem>
        </List>
        )}
        <Divider />
        <List>
          <ListItem>
            <ListItemText primary={t("SIDEBAR.APPLICATIONS")} />
          </ListItem>
          <NavItem icon={<AppsIcon />} label="SIDEBAR.MY_APPLICATIONS" route="applications/" />
          <NavItem icon={<Storefront />} label="SIDEBAR.STORE" route="applications/store" />
          <NavItem icon={<AccountCircleIcon />} label="SIDEBAR.PROFILE" route="applications/profile" />
        </List>
        {(isFactoryAdmin || isAfterSalesAdmin) && (
          <>
            <Divider />
            <List>
              <ListItem>
                <ListItemText primary={t("SIDEBAR.AFTER_SALES")} />
              </ListItem>
              <NavItem icon={<MqttStatusIcon><DevicesOtherIcon /></MqttStatusIcon>} label="SIDEBAR.DEVICES" route="aftersales/devices/" />
              {/* <NavItem icon={<PersonIcon />} label="SIDEBAR.USERS" route="aftersales/users/" /> */}
            </List>
          </>
        )}
        {isFactoryAdmin && (
          <>
            <Divider />
            <List>
              <ListItem>
                <ListItemText primary={t("SIDEBAR.FACTORY")} />
              </ListItem>
              <NavItem icon={<AdminPanelSettingsIcon />} label="SIDEBAR.ADMIN" route="factory/admin/" />
              <NavItem icon={<DevicesOtherIcon />} label="SIDEBAR.DEVICES" route="factory/devices/" />
              <NavItem icon={<HardwareIcon />} label="SIDEBAR.HARDWARES" route="factory/hardwareversions/" />
              <NavItem icon={<WebhookIcon />} label="SIDEBAR.FIRMWARES" route="factory/firmwares/" />
              <NavItem icon={<TerminalIcon />} label="SIDEBAR.PROGRAMMERS" route="factory/programmers/" />
              <NavItem icon={<PersonIcon />} label="SIDEBAR.USERS" route="factory/users/" />
              <NavItem icon={<ScienceIcon />} label="SIDEBAR.SESSIONS" route="factory/sessions/" />
            </List>
          </>
        )}
        {isFactoryAdmin && (
          <>
            <Divider />
            <List>
              <ListItem>
                <ListItemText primary={t("SIDEBAR.BUSINESS")} />
              </ListItem>
              <NavItem icon={<SpeedIcon />} label="SIDEBAR.OPERATIONS" route="business/operations/" />
              <NavItem icon={<TrendingUpIcon />} label="SIDEBAR.STRATEGY" route="business/strategy/" />
              <NavItem icon={<AssessmentIcon />} label="SIDEBAR.CRM_SNAPSHOTS" route="business/crm-snapshots/" />
            </List>
          </>
        )}
        <Divider />
        <List>
          <ListItem>
            <ListItemText secondary={"Version " + (import.meta.env.VITE_VERSION || "DEV")} />
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );
}
